export const FOLDER_ICONS = ['📁', '👤', '🏠', '🏫', '🎨', '⭐', '💼', '🧩', '📋', '🌈'];

export const FOLDER_COLORS: { label: string; value: string; bg: string; text: string; border: string }[] = [
  { label: 'Grau', value: 'gray', bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300' },
  { label: 'Blau', value: 'blue', bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-300' },
  { label: 'Grün', value: 'green', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-300' },
  { label: 'Lila', value: 'purple', bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-300' },
  { label: 'Orange', value: 'orange', bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-300' },
  { label: 'Rosa', value: 'pink', bg: 'bg-pink-50', text: 'text-pink-700', border: 'border-pink-300' },
];

export const PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
export const DEFAULT_PAGE_SIZE = 10;

export const MAX_FOLDER_NAME_LENGTH = 50;
const INVALID_FOLDER_CHARS = /[/\\|:*?"<>]/;

export function getFolderColor(color: string) {
  return FOLDER_COLORS.find((c) => c.value === color) ?? FOLDER_COLORS[0]!;
}

export function validateFolderName(
  name: string,
  existingNames: string[],
  currentName?: string
): string | null {
  const trimmed = name.trim();
  if (!trimmed) return 'Ordnername darf nicht leer sein.';
  if (trimmed.length > MAX_FOLDER_NAME_LENGTH)
    return `Ordnername darf maximal ${MAX_FOLDER_NAME_LENGTH} Zeichen lang sein.`;
  if (INVALID_FOLDER_CHARS.test(trimmed))
    return 'Ordnername enthält ungültige Zeichen (/ \\ | : * ? " < >).';
  const duplicate = existingNames.find(
    (n) => n.toLowerCase() === trimmed.toLowerCase() && n !== currentName
  );
  if (duplicate) return `Ein Ordner „${duplicate}" existiert bereits.`;
  return null;
}
